/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  FORM_HEADING: 'login.form.heading',
  GREETING_HEADING: 'login.greeting.heading',
  GREETING_PARAGRAPH: 'login.greeting.paragraph',
  REGISTER_LABEL: 'login.form.register.text',
};

const enMessages = {
  [IDS.FORM_HEADING]: 'Mortgage Online',
  [IDS.GREETING_HEADING]: 'A fast and easy way to manage your mortgage.',
  [IDS.GREETING_PARAGRAPH]: 'We\'ve rebuilt our site from the ground up to offer you convenience, flexibility, and the power to manage your account from virtually anywhere.',
  [IDS.REGISTER_LABEL]: 'New to Your Mortgage Online?',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.FORM_HEADING]: 'Murabaha Financing Transaction Online',
  [IDS.GREETING_HEADING]: 'A fast and easy way to manage your Murabaha Financing Transaction.',
  [IDS.REGISTER_LABEL]: 'New to Your Murabaha Online?',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
